<template>
    <AuthenticatedLayout
        :title="product.name"
    >
        <template #header>
            <div class="text-center">
                <Heading
                    :label="product.name"
                    :description="product.short_description"
                    class="w-auto"
                    size="xl"
                    :uppercase="false"
                    type="h1"
                />
            </div>
        </template>
    <div class="relative flex flex-col justify-center bg-gray-100 sm:items-center sm:pt-0">

        <div class="max-w-screen-2xl w-full">
            <div class="grid grid-cols-1 gap-3 carousel-product"
                :class="[
                        isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'xl:grid-cols-5' : 'md:grid-cols-5'
                    ]"
            >
                <div
                class="bg-white sm:p-5 p-2 rounded-md shadow-md md:order-0 order-1"
                    :class="[
                        isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'xl:col-span-2' : 'md:col-span-3'
                    ]"
                >
                <img v-if="!product.sortedImages.length" width="200" class="mx-auto" src="/img/cms/logo-color.png" />
                <p v-if="!product.sortedImages.length" class="text-xl font-bold text-center">{{__('The product has no photos')}}</p>
                    <VueAgile
                        class="w-full main"
                        ref="main"
                        :options="optionsMain"
                        :as-nav-for="asNavFor1"
                        v-if="product.sortedImages.length"
                    >
                        <div
                            v-for="(slide, index) in product.sortedImages" :key="index"
                            class="slide rounded-md overflow-hidden"
                            :class="`slide--${index}`"
                        >
                            <img class="w-full h-full object-contain overflow-hidden" :src="slide.link" />
                        </div>
                    </VueAgile>
                    <VueAgile
                        class="thumbnails"
                        ref="thumbnails"
                        :options="optionsThumbnails"
                        :as-nav-for="asNavFor2"
                        v-if="product.sortedImages.length"
                    >
                        <div
                            class="slide slide--thumbniail my-2"
                            v-for="(slide, index) in product.sortedImages"
                            :key="index"
                            :class="`slide--${index}`"
                            @click="$refs.thumbnails.goTo(index)"
                        >
                            <img class="w-full h-full object-contain overflow-hidden shadow-md" :src="slide.link" />
                        </div>

                        <template #prevButton>
                            <SvgIcon
                                name="arrow-left"
                                class="mx-auto"
                            />
                        </template>
                        <template #nextButton>
                            <SvgIcon
                                name="arrow-right"
                                class="mx-auto"
                            />
                        </template>
                    </VueAgile>
                </div>
                <div
                    class="bg-white rounded-md shadow-md md:order-0 order-1"
                    :class="[
                        isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'xl:col-span-3' : 'md:col-span-2'
                    ]"
                >
                    <div class="flex sm:p-5 p-2"
                        :class="[
                            isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'md:flex-row flex-col' : 'flex-col'
                        ]"
                    >
                        <div class="md:mt-0 mt-3 flex flex-col"
                            :class="[
                                isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'md:order-0 order-1 md:mr-3' : 'order-1'
                            ]"
                        >
                            <div class="overflow-auto flex flex-col"
                                v-if="isEngrave(product.options, ['fonts', 'images', 'text_engrave'])"
                            >
                                <CanvasEngraver
                                    @updateData="updateData"
                                    :getArea="getArea"
                                />
                            </div>
                            <div class="bg-gray-100 rounded-md p-3 mt-3"
                                v-if="option.variation && isEngrave(product.options, ['fonts', 'images', 'text_engrave'])"
                            >
                                <div>
                                    <label class="font-bold">{{__('Font size')}}</label>
                                    <div class="relative space-y-1">
                                        <input
                                            v-for="(font, key) in lines" :key="font.id ? font.id : 'font_' + key"
                                            @input="customOption($event, font, key, 'font')"
                                            :value="font.fontSize"
                                            class="w-full outline-none"
                                            type="range"
                                            step="0.1"
                                            :max="calcMaxValue(font).toFixed(2)"
                                            :min="5"
                                        />
                                    </div>
                                </div>
                                <hr class="border-gray-300 my-3">
                                <div class="relative space-y-1">
                                    <label class="font-bold">{{__('Text position')}}</label>
                                    <div>
                                        <template v-for="(line, key) in lines" :key="line.id ? line.id : 'line_' + key">
                                        <input
                                            v-if="line"
                                            @input="customOption($event, line, key, 'position')"
                                            :value="line.x"
                                            :disabled="line.w + 10 > getArea('w')"
                                            class="w-full outline-none"
                                            type="range"
                                            :min="getArea('x')"
                                            :max="getArea('w') + getArea('x') - line.w"
                                        />
                                        </template>
                                    </div>
                                </div>
                                <div class="flex justify-end"
                                    v-if="custom"
                                >
                                    <Button
                                        @click="option.reset = true"
                                    >{{__('Reset')}}</Button>
                                </div>
                            </div>
                            <div class="bg-gray-100 rounded-md mt-3 p-3 flex flex-wrap items-center justify-center md:mt-auto">
                                <div
                                    class="p-2 my-1 rounded-md font-bold text-md flex items-center justify-between border-2 border-gray-900 bg-gray-900 text-gray-200 shadow-md"
                                >
                                    <span>
                                        {{ getTotalPriceWithCount( product, form.count ) }}
                                    </span>
                                </div>
                                <Button
                                    color="red"
                                    padding="xl"
                                    class="mx-2 my-1 font-bold"
                                    :class="[
                                        isValid ? '' : 'opacity-50'
                                    ]"
                                    type="button"
                                    @click="ev => { if(isValid) addToCart() }"
                                >
                                    <SvgIcon
                                        name="cart"
                                        :size="18"
                                        class="mr-1"
                                    />
                                    {{isInCart ? __('Go to cart') : __('Add to cart')}}
                                </Button>

                            </div>
                        </div>
                        <div class="w-full"
                            :class="[
                                isEngrave(product.options, ['fonts', 'images', 'text_engrave']) ? 'md:order-1 order-0' : 'order-0'
                            ]"
                        >
                            <div class="p-3 bg-gray-100 rounded-md mb-3"
                                v-if="isEngrave(product.options, ['fonts', 'images', 'text_engrave'])"
                            >
                                <CustomSelect
                                    :label="__('Ballpoint pen color')"
                                    id="option.variation"
                                    :data="product.variations"
                                    v-model="option.variation"
                                    class="mb-3"
                                    v-if="product.variations.length > 1"
                                >
                                <p class="small mt-0.5 text-gray-500 text-xs text-left">{{ __('Each pen will have the same selected color') }}</p>
                                </CustomSelect>
                                <CustomSelect
                                    v-if="fonts && isEngrave(product.options, 'fonts')"
                                    :label="__('Fonts')"
                                    :disabled="!option.variation"
                                    :data="fonts"
                                    v-model="option.font"
                                    class="mb-3"
                                />
                                <CustomSelect
                                    v-if="pictograms && isEngrave(product.options, 'images')"
                                    :label="__('Images')"
                                    id="option.pictogram"
                                    :disabled="!option.variation"
                                    :data="pictograms"
                                    v-model="option.pictogram"
                                    class="mb-3"
                                    :none-option="true"
                                />
                                <InputLabel
                                    type="textarea"
                                    id="option.text"
                                    v-if="isEngrave(product.options, 'text_engrave')"
                                    :label="__('Text to engrave')"
                                    :disabled="!option.variation"
                                    :maxLines="option.variation ? option.variation.engrave.option.max_lines : null"
                                    v-model="option.text"
                                    :maxLength="option.variation ? option.variation.engrave.option.max_characters : null"
                                />
                            </div>
                            <div class="bg-gray-100 rounded-md p-3">
                                <Select
                                    :label="__('Color')"
                                    :data="product.options.color.value"
                                    v-model="form.color"
                                    v-if="product.options.color && isTrue(product.options.color.status) && product.options.color.value.length"
                                    id="color"
                                    class="mb-3"
                                >
                                    <template #display="props">
                                        <div
                                            class="px-1 rounded-md font-bold flex items-center space-x-2"
                                        >
                                            <div class="h-10 w-10 rounded-full border-2" :style="'background-color:' + props.value.color"></div>
                                            <span>{{ props.value.title }}</span>
                                        </div>
                                    </template>

                                    <template #default="props">
                                        <Option
                                            v-for="(item, key) in props.data"
                                            :key="key"
                                            @click="props.clicked(item)"
                                            class="flex justify-between"
                                            :class="[
                                                props.active != item ? 'hover:bg-gray-50' : '',
                                            ]"
                                            :selected="props.active == item"
                                        >
                                            <div
                                                class="px-1 rounded-md font-bold flex items-center space-x-2"
                                            >
                                                <div class="h-10 w-10 rounded-full border-2" :style="'background-color:' + item.color"></div>
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </Option>
                                    </template>
                                </Select>
                                <InputLabel
                                    type="textarea"
                                    :label="__('Aditional information for the seller (optional)')"
                                    :rows="3"
                                    v-model="form.aditional"
                                >
                                    <template #description>
                                        {{ __('If you have any comments on your order, please write them here.') }}
                                    </template>
                                </InputLabel>
                            </div>
                            <div class="bg-gray-100 rounded-md p-3 mt-3" v-if="product.pieces_item.filter(item => isTrue(item.display)).length">
                                <h1 class="font-bold text-md text-gray-700">
                                    {{
                                        product.pieces_type == 'pieces' ? __('Need more than :quantity pieces? (optional)', { quantity: product.quantity }) : __('Choose the number of pieces')
                                    }}
                                </h1>
                                <div class="grid gap-2"
                                    :class="{
                                        ['grid-cols-1'] : product.pieces_type == 'pieces',
                                        ['grid-cols-2'] : product.pieces_type != 'pieces'
                                    }"
                                >
                                    <div
                                        v-if="product.pieces_type == 'pieces'"
                                        class="p-2 rounded-md font-bold text-md flex items-center justify-between transition duration-300 cursor-pointer border-2"
                                        @click="form.count = null"
                                        :class="{
                                            ['border-gray-900 bg-gray-900 text-gray-200 shadow-md'] : !form.count,
                                            ['bg-gray-200 hover:border-gray-300 text-gray-700 hover:bg-gray-300 hover:text-gray-700'] : form.count,
                                        }"
                                    >
                                        <span>{{__('None')}}</span>
                                    </div>
                                    <template
                                        v-for="item in product.pieces_item"
                                        :key="item"
                                    >
                                    <div
                                        class="p-2 rounded-md font-bold text-md flex items-center justify-between group transition duration-300 cursor-pointer border-2"
                                        :class="{
                                            ['border-gray-900 bg-gray-900 text-gray-200 shadow-md'] : form.count && form.count.quantity == item.quantity,
                                            ['bg-gray-200 hover:border-gray-300 text-gray-700 hover:bg-gray-300 hover:text-gray-700'] : form.count == null || form.count.quantity != item.quantity,
                                        }"
                                        v-if="isTrue(item.display)"
                                        @click="form.count = item"

                                    >
                                        <span v-if="product.pieces_type == 'pieces'">+ {{ item.quantity }} {{ __('pieces') }}</span>
                                        <span v-else>{{ item.quantity }}</span>

                                        <span
                                            class="text-xs text-red-700 whitespace-nowrap transition duration-300"
                                            :class="{
                                                ['bg-red-700 text-gray-200 px-1 rounded-md'] : form.count && form.count.quantity == item.quantity,
                                                ['text-red-700 px-1'] : form.count == null || form.count.quantity != item.quantity
                                            }"
                                        >
                                            <span v-if="product.pieces_type == 'pieces'">+</span>
                                            {{ getPrice(item.price) }}
                                        </span>
                                    </div>
                                    </template>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="max-w-screen-xl w-full py-10">
            <div class="bg-white sm:p-5 p-2 rounded-md shadow-md">
                <Tabs
                    :tabs="[
                        { slug: 'desc', title: __('Description product') },
                        { slug: 'reviews', title:__('Reviews') },
                        { slug: 'fqa', title:__('FQA') },
                        { slug: 'downloads', title:__('Downloads') },
                    ]"
                >
                    <ItemTab
                        key="desc"
                        class="ql-snow -mx-4"
                    >
                        <div class="ql-editor content" v-html="product.description"></div>
                    </ItemTab>
                    <ItemTab
                        key="reviews"
                        class="carousel-review"
                    >
                        <VueAgile
                            class="w-full main"
                            :options="carouselReview"
                            v-if="product.reviews.length"
                        >
                            <div
                                v-for="(slide, index) in product.reviews" :key="index"
                                class="slide rounded-md overflow-hidden mb-3"
                                :class="`slide--${index}`"
                            >
                                <div class="relative flex flex-col items-start px-4 py-7 bg-gray-50 rounded-md mt-2 shadow-inner">
                                    <h1 class="font-bold text-base">{{slide.name}}</h1>
                                    <p class="text-gray-400 text-xs mb-1" v-if="slide.addons">{{slide.addons}}</p>
                                    <img src="/img/cms/quote.png" class="h-auto opacity-20 absolute top-2 left-2" width="20" />
                                    <div class="whitespace-pre-line overflow-auto" style="max-height:200px;" v-html="slide.content"></div>
                                    <img src="/img/cms/quote.png" class="h-auto opacity-20 absolute bottom-2 right-2 transform rotate-180" width="20" />
                                </div>
                            </div>

                            <template #prevButton>
                                <SvgIcon
                                    name="arrow-left"
                                    class="mx-auto"
                                />
                            </template>
                            <template #nextButton>
                                <SvgIcon
                                    name="arrow-right"
                                    class="mx-auto"
                                />
                            </template>
                        </VueAgile>
                        <div v-else class="font-bold mt-3">{{__("This product don't have any reviews!")}}</div>
                    </ItemTab>
                    <ItemTab key="downloads">
                        <ul class="mt-2"
                            v-if="product.files.length"
                        >
                            <li
                                v-for="(file, index) in product.files" :key="index"
                                class="p-2 font-bold mb-1 bg-gray-100 rounded-md"
                            >
                                <span class="mr-1">{{ file.name }}</span>-
                                <a download class="ml-1 text-red-700 hover:text-red-800" :href="file.link">{{ file.file_name }}</a>
                            </li>
                        </ul>
                        <div v-else class="font-bold mt-3">{{__("This product don't have any files to download!")}}</div>
                    </ItemTab>
                    <ItemTab key="fqa">

                        <Questions
                            :questions="product.questions"
                            v-if="product.questions.length"
                        />
                        <div v-else class="font-bold mt-3">{{__("This product don't have any questions!")}}</div>

                    </ItemTab>
                </Tabs>
            </div>
        </div>

    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';
import CanvasEngraver from 'COMP/Canvas/CanvasEngraver';
import Button from 'UI/Button';
import Tabs from 'COMP/Tabs/Container';
import ItemTab from 'COMP/Tabs/Tab';
import Questions from 'COMP/Accordion/Questions';
import Select from 'COMP/CustomSelect/Select';
import Option from 'COMP/CustomSelect/Option';
import { VueAgile } from 'vue-agile'

import { useForm, usePage } from '@inertiajs/inertia-vue3'

import {computed, provide, ref, watch } from 'vue';
import { unserialize } from 'php-serialize';

import {
    getPrice,
    checkError,
    getTotalPriceWithCount,
    sortProduct,
    isEngrave,
    isTrue
} from 'helper';
import { Inertia } from '@inertiajs/inertia';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        CanvasEngraver,
        Button,
        Select,
        Option,
        VueAgile,

        Questions,
        Tabs,
        ItemTab,
    },
    props: {
        product: Object,
        fonts: Object,
        engraves: [Array, Object],
        pictograms: [Array, Object],
    },
    setup(props) {

        // Option engrave
        const option = ref({
            variation: props.product.variations.length > 1 ? null : props.product.variations[0],
            font: props.fonts ? props.fonts[0] : false,
            text: '',
            color: props.product.variations.length > 1 ? null : ( props.product.variations.length ? props.product.variations[0].engrave.color : null ),
            pictogram: null,
            position: [],
            fontSize: [],
            reset: false,
        });
        const errors = ref({});
        provide('option', option);

        if(isEngrave(props.product.options, 'text_engrave')){

            watch(() => option.value.variation, (val) => {
                if(val) option.value.color = val.engrave.color;
            })

        }
        if(props.fonts && isEngrave(props.product.options, 'fonts')){

            var newStyle = document.createElement('style');
            props.fonts.forEach((el, key) => {
                if (el.src) {
                    newStyle.appendChild(document.createTextNode("\
                        @font-face {\
                            font-family: '"+el.family+"';\
                            src: url('/storage/fonts/"+el.src+"');\
                        }\
                    "));
                }
            })
            document.head.appendChild(newStyle);
        }

        function getArea(value = null){
            let area = unserialize(option.value.variation.engrave.option.area);

            if(value) return area[value];
            else return area;
        }

        const lines = ref([]);
        provide('lines', lines);

        const form = useForm({
            product: props.product,
            aditional: '',
            color: null,
            count: props.product.pieces_type == 'pieces' ? null : props.product.pieces_item.find((e) => { return e.display == true || e.display == '1'}),

            option: option.value,
        });


        const isInCart = ref(false);
        const addToCart = () => {

            if(isInCart.value == true) Inertia.visit(route('cart'));
            else {
                form
                .post(route('add_to_cart'), {
                    preserveScroll: true,
                    onSuccess: (e) => {
                        if(usePage().props.value.flash.success) {
                            isInCart.value = true;
                        }
                    },
                })
            }
        }

        function updateData(val) {
            if(option.value.reset) custom.value = false;
        }

        const custom = ref(false);
        function customOption(e, el, key, type) {

            let val = Number(e.target.value);
            custom.value = true;
            if(type == 'position'){
                el.position = val;
                el.x = el.position;

                option.value.position[key] = val;

                el.changePos = true;
            }
            else if( type == 'font') {
                if(val > Number(e.target.max)) {
                    val = Number(e.target.max);
                    errors.value['font_' + key] = app.__('validation.max.numeric', { attribute: app.__('font size'), max: e.target.max });

                    setTimeout(() => {
                        errors.value['font_' + key] = null;
                    }, 4000)
                }
                if(el.fontSize, val) el.scaled = true;

                el.fontSize = val;
                el.manualScaleFont = true;
                option.value.fontSize[key] = val;
            }
        };

        function calcMaxValue(item) {
            const MAX = getArea('h');
            let count = 0;

            lines.value.forEach((el, key) => {
                if(item.id != el.id) {
                    count += el.fontSize;
                }
            });

            item.maxH = MAX - count;
            return MAX - count;
        }

        const getSizeFonts = computed(() => {
            let size = 0;

            lines.value.forEach((el, key) => { size += el.fontSize });

            return  getArea('h') - size;
        });

        const isValid = computed(() => {
            let valid = true;


            return valid;
        })


        return {
            option,
            form,
            addToCart,
            isValid,

            getArea,
            updateData,
            customOption,
            lines,
            calcMaxValue,
            custom,

            errors,
            isInCart,
            getSizeFonts,

            // helper
            getPrice,
            checkError,
            getTotalPriceWithCount,
            sortProduct,
            isEngrave,
            isTrue,
        }
    },
    data () {
		return {
			asNavFor1: [],
			asNavFor2: [],
			optionsMain: {
				dots: false,
				fade: true,
				navButtons: false
			},
			optionsThumbnails: {
				autoplay: true,
				centerMode: true,
				dots: false,
				navButtons: false,
				slidesToShow: 2,
				responsive: [
                    { breakpoint: 600, settings: { slidesToShow: 3 } },
                    { breakpoint: 1000, settings: { navButtons: true } }
                ]
			},
            carouselReview: {
                autoplay: true,
                autoplaySpeed: 8000,
                speed: 1000,
                timing: 'ease-in-out',
            }
		}
    },
    mounted () {
		this.asNavFor1.push(this.$refs.thumbnails)
		this.asNavFor2.push(this.$refs.main)
	}
}
</script>

<style lang="postcss">
.carousel-product .thumbnails {
	margin: 0 -5px;
	width: calc(100% + 10px);
    @apply px-5;
}

.carousel-product .agile.main {
    @apply mb-5;
}
.carousel-product .agile__nav-button {
    color: #ccc;
    font-size: 24px;

    @apply bg-transparent border-none cursor-pointer duration-300;
}
.carousel-product .agile__nav-button {
    @apply absolute transform -translate-y-1/2 top-1/2;
}
.carousel-product .agile__nav-button--prev {
	@apply -left-2;
}
.carousel-product .agile__nav-button--next {
	@apply -right-2;
}
.carousel-product .agile__nav-button:hover {
    color: #888
}
.carousel-product .agile__dot {
    @apply mx-1;
}
.carousel-product .agile__dot button {
    background-color: #eee;
    border-radius: 50%;
    font-size: 0;
    line-height: 0;

    @apply p-0 m-0 w-3 h-3 block cursor-pointer border-none duration-300;
}
.carousel-product .agile__dot--current button,
.carousel-product .agile__dot:hover button {
    background-color: #888;
}

.carousel-product .slide--thumbniail.agile__slide--active,
.carousel-product .slide--thumbniail.agile__slide--active:hover {
    @apply opacity-100;
}
.carousel-product .slide {
    @apply justify-center flex text-white items-center;
}
.carousel-product .slide--thumbniail {
    @apply transition duration-300 px-1 h-24 cursor-pointer opacity-40;
}
.carousel-product .slide--thumbniail:hover {
    @apply opacity-60;
}

.carousel-review .agile__dots{
    @apply bottom-3 absolute transform left-1/2 -translate-x-1/2;
}
.carousel-review .agile__dot{
    @apply mx-1;
}
.carousel-review .agile__dot button{
    border-radius: 50%;
    font-size: 0;
    line-height: 0;

    @apply w-3 h-3 transition duration-300 p-0 m-0 block cursor-pointer border border-red-700 bg-transparent;
}
.carousel-review .agile__dot--current button,
.carousel-review .agile__dot:hover button{
	@apply bg-red-700;
}

.clear-number::-webkit-outer-spin-button,
.clear-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.clear-number[type=number] {
  -moz-appearance: textfield;
}
</style>
